export default "__VITE_ASSET__B9tnV7mf__"